<section class="top-page">
  <img class="top-page__image" src="assets/images/top_icon.svg" alt="Top Icon" />
  <section>
    <h1 class="top-page__title">{{'TOP_PAGE.TITLE' | translate}}</h1>
    <div class="top-page__desc">
      <span>{{'TOP_PAGE.DESC1' | translate}}</span>
      <span>{{'TOP_PAGE.DESC2' | translate}}</span>
    </div>
  </section>


  <!-- Restrictions Box -->
  <section>
    <div class="restrictions">
      <h3 class="restrictions__title">{{'TOP_PAGE.RESTRICTION-TITLE' | translate}}</h3>
      <ul class="restrictions__list">
        <li class="restrictions__item">
          <span><cds-icon [icon]="closeIconFilled"></cds-icon></span>
          <span class="restrictions__text">{{'TOP_PAGE.RESTRICTION-DESC-P1' | translate}}</span>
        </li>
        <li class="restrictions__item">
          <span><cds-icon [icon]="closeIconFilled"></cds-icon></span>
          <span class="restrictions__text">{{'TOP_PAGE.RESTRICTION-DESC-P2' | translate}}</span>
        </li>
      </ul>
      <p class="restrictions__note">
        {{'TOP_PAGE.RESTRICTION-DESC-P3' | translate}}<a href="https://www.manulife.co.jp/ja/individual/contact.html"
          target="_blank" class="contact-link">{{'TOP_PAGE.RESTRICTION-LINK' |
          translate}}</a>{{'TOP_PAGE.RESTRICTION-DESC-P4' | translate}}
      </p>
    </div>
  </section>

  <!-- Documents Section -->
  <section class="section">
    <h2 class="section-title">{{'TOP_PAGE_SECTION.TITLE' | translate}}</h2>
    <p class="section-description" [innerHTML]="'TOP_PAGE_SECTION.DES' | translate"></p>
    <p class="section-note">
      <span class="icon">※</span><span> {{'TOP_PAGE_SECTION.P1' | translate}}</span>
    </p>
    <p class="section-note">
      <span class="icon">※</span><span> {{'TOP_PAGE_SECTION.P2' | translate}}</span>
    </p>
    <ul class="section-sublist">
      <li>{{'TOP_PAGE_SECTION.List1' | translate}}</li>
      <li>{{'TOP_PAGE_SECTION.List2' | translate}}</li>
      <li>{{'TOP_PAGE_SECTION.List3' | translate}}</li>
    </ul>
  </section>
</section>
<app-document-accordion [documents]="documents"></app-document-accordion>

<section class="claim">
  <h2 class="claim__title">{{'TOP_PAGE_REQUEST.TITLE' | translate}}</h2>
  <p class="claim__note">
    {{'TOP_PAGE_REQUEST.DESC' | translate}}
  </p>
  <ul class="claim__list">
    @for (req of reqList; track req; let i = $index) {
    <li class="claim__item">
      <span class="claim__number">{{ i + 1 }}</span>
      <span class="claim__text">{{ req | translate}}</span>
    </li>
    }
  </ul>
  <div class="claim__btn__container">
    <cds-button class="claim__btn" size="lg" matButton (click)="openDialog()">
      {{'BUTTONS.BENEFIT_CLAIM' | translate}}
    </cds-button>
  </div>
</section>